<template>
    <div class="aside">
        <div class="hoverDiv" @click="drawer = true">
            联系我们
            <img class="hoverimg" src="../assets/img/cebianImg/hoverbtnbg.gif" height="9" width="13">
        </div>
        <el-drawer
                :visible.sync="drawer"
                :with-header="false"
                size="21%">
            <div class="drawer_btn" @click="drawer = true">
                联系我们
                <img class="hoverimg" src="../assets/img/cebianImg/hoverbtnbg.gif" height="9" width="13">
            </div>
            <div class="drawer_content">
                <div class="drawer_con1">
                    <img src="../assets/img/cebianImg/tel.png" height="31" width="31">
                    <div class="con2">
                        <span class="f1">咨询热线：</span>
                        <span style="font-size: 18px;">133-6285-0188</span>
                    </div>
                </div>
                <div class="drawer_con1">
                    <img src="../assets/img/cebianImg/zxkfqq.png" height="31" width="31">
                    <div class="con2">
                        <span class="f1">在线客服：</span>
                        <span class="kefuQQ" style="font-size: 12px">客服一<a target="_blank"
                                                                           href="http://wpa.qq.com/msgrd?v=3&amp;uin=522417107&amp;site=qq&amp;menu=yes"></a></span>

                    </div>
                </div>
                <div class="drawer_con1">
                    <img src="../assets/img/cebianImg/weixin.png" height="31" width="31">
                    <div class="con2">
                        <span class="f1">企业二维码：</span>
                        <span><img src="../assets/img/lxerweima8.png" height="73" width="73"></span>
                    </div>
                </div>
                <div class="drawer_con1">
                    <div class="con2" style="padding-left: 40px">
                        <span class="f1" style="font-weight: bold;">公司官网：</span>
                        <span>
                            <a href="http://www.joyingtec.com"
                               style="text-decoration:none; font-size: 14px; color: black">
                                www.joyingtec.com</a></span>
                    </div>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
      };
    },
    methods: {}
  }
</script>

<style lang="less">
    /*注意: 这里没有关键字scoped 会影响全局*/
    .aside{
        .el-drawer {
            flex-direction: row !important;
            background: rgba(117, 179, 145, 0) !important;
            box-shadow: 0 0 0 0 !important;

            .el-drawer__body {
                display: flex;
                align-items: center;
                flex-direction: row !important;
                justify-content: flex-end !important;
            }
        }

        .el-drawer:focus {
            outline: none;
        }
    }

        /*抽屉关闭时的按钮*/
    .hoverDiv {
        transform: translate(0, -50%);
        padding-top: 20px;
        z-index: 9;
        color: #eeeeef;
        font-size: 16px;
        position: absolute;
        top: 50%;
        width: 30px;
        height: 120px;
        background-color: #009AFF;
        cursor: pointer;
        right: 17px;
        text-align: center;
        border-radius: 3px;
        box-shadow: -2px 2px 5px #4c4c4c;
    }

    /*抽屉组件上的按钮*/
    .drawer_btn {
        padding-top: 20px;
        color: #eeeeef;
        top: 50%;
        width: 30px;
        height: 140px;
        cursor: pointer;
        border-radius: 3px 0 0 3px;
        box-shadow: -2px 2px 5px #4c4c4c;
        background-color: #009AFF;
        text-align: center;
        z-index: 3;
    }

    /*抽屉上的内容*/
    .drawer_content {
        float: right;
        width: 250px;
        background: rgba(0, 154, 255, 1);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 20px;
        color: #fff;
        z-index: 4;
    }

    .drawer_con1 {
        border-bottom: 1px solid #6a6a6a;
        padding: 30px 0;
        display: flex;
        flex-direction: row;

        > img {
            margin-top: 30px;
            padding-right: 20px;
        }

        .con2 {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            .f1 {
                font-size: 14px;
                _font-size: 14px;
                *font-size: 15px;
                font-weight: bold;
                padding: 10px 0;
            }
        }

    }

    .kefuQQ a {
        background: url(../assets/img/cebianImg/button-custom-qq.gif) no-repeat;
        width: 70px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
    }

    .kefuQQ a:hover {
        background: url(../assets/img/cebianImg/button-custom-qq-h.gif) no-repeat;
    }
</style>
